<div *ngIf="!(isReactiveForm$ | async) && isFilterForm()" class="sb-search-filter-bar">
    <div class="sb-search-filter-button-wrapper" *ngFor="let fb of savedFilters">
        <mat-button-toggle-group>
            <mat-button-toggle
                mat-flat-button
                *ngIf="activeFilterName !== fb.name"
                (click)="filterButtonClicked($event)"
                id="{{ fb.id }}"
            >
                {{ fb.name }}
            </mat-button-toggle>
            <mat-button-toggle
                mat-stroked-button
                *ngIf="activeFilterName === fb.name"
                (click)="filterButtonClicked($event)"
                id="{{ fb.id }}"
            >
                {{ fb.name }}
            </mat-button-toggle>
            <mat-button-toggle
                mat-flat-button
                class="drop-down-button"
                [matMenuTriggerFor]="dropdownMenuOne"
            >
                <mat-icon>arrow_drop_down</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-menu #dropdownMenuOne="matMenu">
            <button (click)="updateFilter(false, fb.name)" mat-menu-item>Update</button>
            <button (click)="deleteFilter(false, fb.name)" mat-menu-item>Delete</button>
        </mat-menu>
    </div>
</div>
<app-sb-messages [messages]="msgs"></app-sb-messages>
<form
    *ngIf="isReactiveForm$ | async"
    [formGroup]="reactiveForm"
    #form="ngForm"
    (submit)="search(this.reactiveForm.value)"
    class="mb-3"
>
    <div class="row gy-3 gx-2 gx-xl-3 align-items-center">
        <div class="col-12 col-sm-auto">
            <sb-period-picker
                formControlName="period"
                *ngIf="
                    context.formId === 'portfolio-report-filter-form' ||
                    context.formId === 'transaction-filter-form'
                "
            ></sb-period-picker>
            <mat-form-field
                appearance="fill"
                *ngIf="
                    context.formId === 'position-report-filter-form' ||
                    context.formId === 'position-filter-form'
                "
            >
                <mat-label>Date</mat-label>
                <input formControlName="date" matInput [matDatepicker]="dp" />
                <mat-hint>Select a date YYYY-MM-DD</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="dp">
                    <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
                </mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-auto">
            <sb-account-filter-select
                formControlName="accounts"
                [control]="reactiveForm.controls.accounts"
                [includeBrokerAccounts]="context.formId === 'transaction-filter-form'"
                valueKey="accountId"
            ></sb-account-filter-select>
        </div>
        <div
            class="col-12 col-sm-auto mt-sm-0 text-center"
            *ngIf="context.formId === 'position-filter-form'"
        >
            <mat-checkbox formControlName="showNetted">Show netted</mat-checkbox>
        </div>
        <div
            class="col-12 col-sm-auto mt-sm-0 text-center"
            *ngIf="context.formId === 'transaction-filter-form'"
        >
            <mat-checkbox formControlName="showCancelled">Show cancelled</mat-checkbox>
        </div>
        <div class="col-12 col-md-auto text-center text-sm-right">
            <button type="submit" class="btn primary me-3 mb-3">
                Search
                <sb-pending-button-indicator
                    [state]="searchState"
                ></sb-pending-button-indicator>
            </button>
            <!-- TODO: enable once we've added user settings service for storing filters and modal for filter name -->
            <!--<button
                type="button"
                class="btn secondary mb-3"
                [disabled]="reactiveForm.pristine"
                (click)="saveFilter(this.reactiveForm.value)"
            >
                Save
            </button>-->
        </div>
    </div>
    <!-- TODO: replace with sb-error-alert once it's merged -->
    <div
        role="alert"
        class="critical"
        style="width: fit-content; max-width: 768px"
        *ngIf="reactiveForm.invalid && form.submitted"
        [@fadeInOut]
    >
        <header>
            <h3 class="h4 mb-0">Invalid or missing info</h3>
        </header>
        <main>
            The form contains one or more errors, please correct them and try again.
        </main>
    </div>
    <div *ngIf="quickFilters.length > 0" class="d-flex align-items-center mt-3">
        <label class="font-weight-bold text-nowrap">Saved filters</label>
        <div class="faded-container-v">
            <div class="overflow-x-auto invisible-scroll" style="overflow-y: hidden">
                <sb-badges
                    [(badges)]="quickFilters"
                    (activeBadgeChange)="loadFilter($event.data)"
                    dismissible="true"
                    allowActive="true"
                ></sb-badges>
            </div>
        </div>
    </div>
</form>
<form
    [class.d-none]="isReactiveForm$ | async"
    [formGroup]="form"
    (ngSubmit)="submit(model)"
    [ngClass]="!isFilterForm() ? 'ui-fluid form-group' : 'ui-g ui-fluid form-group'"
>
    <formly-form
        [model]="model"
        [fields]="fields"
        [options]="options"
        [form]="form"
        (modelChange)="modelChange(model)"
        #formlyForm
    ></formly-form>
    <div *ngIf="!isFilterForm()" class="sb-form-button-bar">
        <button
            type="button"
            [disabled]="transactionGroupId"
            class="btn secondary"
            (click)="onReset()"
        >
            Reset
        </button>
        <button type="submit" class="ms-3 btn primary">{{ defaultButtonLabel() }}</button>
    </div>
    <div
        *ngIf="isFilterForm() && !(printLayout$ | async)"
        class="sb-search-form-button-bar"
    >
        <div style="display: flex; flex-wrap: wrap">
            <div class="mt-2">
                <button type="submit" class="btn secondary">
                    <tabler-icon
                        name="search"
                        class="me-2"
                        style="height: 1rem; width: 1rem"
                    ></tabler-icon>
                    {{ defaultButtonLabel() }}
                </button>
            </div>
            <div class="sb-save-filter-wrapper">
                <mat-form-field appearance="fill">
                    <mat-label>Name for template</mat-label>
                    <input
                        type="text"
                        #filterSaveTextBox
                        matInput
                        [disabled]="filterSaveDisabled"
                        (keyup)="onFilterTextKeyUp($event.target.value)"
                    />
                    <mat-hint>Search to save as template</mat-hint>
                </mat-form-field>
                <div class="mt-2">
                    <button
                        [disabled]="filterSaveButtonDisabled"
                        type="button"
                        (click)="createFilter($event)"
                        title="Save Search as Filter"
                        class="sb-fit-content-button ms-2 btn primary"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>
<ng-container *ngIf="debug && !isFilterForm()">
    <div>
        <button class="btn secondary" (click)="openConfigurationDialog()">
            Show Widget Config
        </button>
    </div>
    <pre>Form model: {{ model | json }}</pre>
    <pre>Submit model: {{ getSubmitModel(model) | json }}</pre>
</ng-container>
<div
    *ngIf="isPrinting"
    class="sb-print-form"
    [innerHTML]="getPrettyPrintedFormValues()"
></div>
<ng-template #submissionSuccessful>
    <div class="d-flex align-items-center">
        <div>Stay on the page to add something more or</div>
        <a
            class="mx-1 btn btn-sm secondary cursor-pointer"
            [href]="this.formConfigContext.redirectPathOnSuccess"
        >
            navigate to the table
            <tabler-icon
                style="height: 1rem; width: 1rem"
                name="external-link"
            ></tabler-icon>
        </a>
    </div>
</ng-template>
